import { t } from '@aquabox/shared';

/** Bayat açık sefer rozeti: tripDate İstanbul bugününden eski, sefer hâlâ açık. */
export function StaleBadge() {
  return (
    <span
      data-testid="stale-badge"
      style={{
        marginLeft: 6,
        padding: '1px 7px',
        borderRadius: 999,
        background: 'var(--warning)',
        color: '#fff',
        fontSize: 11,
        fontWeight: 700,
      }}
    >
      {t('trips.staleBadge')}
    </span>
  );
}
